import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { change } from 'redux-form';
import SignUpLandingShell, { SignUpLandingHowItWorksStep } from './_shared/SignUpLandingShell';
import { STEP_EQ_LEAD_YOUR_INFORMATION } from '@components/ApplyWizard/ApplyWizardSteps';
import { flowStepComplete } from '@utils/gaFlow';

const HERO_IMAGE_SRC = 'https://media.tento.co/photos/eq-landing-hero.jpg';
const HIW_IMAGE_SRC = 'https://media.tento.co/photos/eq-landing-hiw.jpg';

const HIW_STEPS: SignUpLandingHowItWorksStep[] = [
  {
    number: '01',
    title: 'Submit your application',
    body: 'Fill out our seamless application in less than 5 minutes.',
  },
  {
    number: '02',
    title: 'Pre–qualify in minutes',
    body: 'Find out immediately if you pre–qualify, then securely upload your business bank statements for final approval.',
  },
  {
    number: '03',
    title: 'Get funded',
    body: 'Secure your funding in 1-2 days, and get the equipment you need to keep your business running.',
  },
];

export const EQLandingPage: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const handleApply = () => {
    flowStepComplete('apply_equipment', 'landing');
    dispatch(change('application', 'application_type', 'eqlead'));
    history.push(STEP_EQ_LEAD_YOUR_INFORMATION);
  };

  return (
    <SignUpLandingShell
      heroImage={HERO_IMAGE_SRC}
      heroAlt="Small business operator using equipment financed through Tento"
      heroLabel="GET FINANCED TODAY"
      heroHeadline="Equipment financing made for small business"
      heroParagraph="Fast, flexible financing to get the equipment your business needs. Same day approvals and just one point of contact, no runaround."
      hiwImage={HIW_IMAGE_SRC}
      hiwAlt="Small business greenhouse financed by Tento"
      hiwHeadline="How financing with us actually works"
      hiwSteps={HIW_STEPS}
      hiwBodySize="sm"
      bottomCtaHeadline="Keep your business moving, growing, and thriving with financing today."
      primaryCtaLabel="Apply Now"
      onPrimaryCta={handleApply}
    />
  );
};

export default EQLandingPage;
